import { createFileRoute } from '@tanstack/react-router';
import { CrewPage } from '@/features/crew/CrewPage.tsx';
import { CrewShell } from '@/features/crew/CrewShell.tsx';
import { requireSignedIn } from '@/lib/route-guards.ts';

/** /crew — phone-first barn log (own focused layout, outside the office shell). */
export const Route = createFileRoute('/crew')({
  beforeLoad: ({ context, location }) => requireSignedIn(context, location),
  component: CrewRoute,
});

function CrewRoute() {
  return (
    <CrewShell>
      <CrewPage />
    </CrewShell>
  );
}
